export enum Colors {
  Pink = "e8187a",
  DarkBlue = "11326c",
}
